// Opens header mega menus on hover (desktop with a mouse only).
// Click and keyboard behaviour from details-disclosure.js stays unchanged.
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const CLOSE_DELAY = 180;

  const setOpen = (details, open) => {
    if (details.open === open) return;
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    details.querySelector('summary')?.setAttribute('aria-expanded', open);
  };

  const init = () => {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';

      const details = menu.querySelector('details.mega-menu');
      if (!details) return;
      let closeTimer;

      menu.addEventListener('pointerenter', () => {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((other) => {
          if (other !== details) setOpen(other, false);
        });
        setOpen(details, true);
      });

      // A mouse click on an already hover-opened menu should not close it.
      details.querySelector('summary')?.addEventListener('click', (event) => {
        if (canHover.matches && event.detail > 0 && details.open) event.preventDefault();
      });

      menu.addEventListener('pointerleave', () => {
        if (!canHover.matches) return;
        closeTimer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
